import { status } from 'skin/event/status';

function row (obj, ms, story, data, d, action) {
    // data.setCell(obj.table, obj.key, 1, '!');
    return status.ignore;
}

export default row;